import { TableCell, Stack, Box } from '@mui/material';
import { Formik } from 'formik';
import { AppPrimaryButton, AppRadioBox } from 'shared/components/AppComponents';
import { Data, TableMeta } from './VirtualizedTable';

import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import TypographyLevel from 'shared/components/Typography';
import { formattingDate } from 'shared/helpers/FormatDate';
import { useSelector, useDispatch } from 'react-redux';
import { ManagePacketService } from 'services';
import { Toast, Utils } from 'shared/helpers';

import { typeMap } from './data/typeMap';
import { formattingAction } from 'shared/helpers/FormatAction';
import { CarryAppActions } from 'state/carriesapplication/Action';
import { ReviewPacketData } from '../../solicitor-viewer/SolicitorDocumentPage';
import { Vertices } from '../../solicitor-viewer/definition/vertices';
import { VerticeSystem } from '../../solicitor-viewer/definition/abstract';
import {
    DeleteIcon,
    ChevronDown,
    // CellIcon,
    ChevronUp,
} from 'shared/components/AppIcons';
import HighlightIcon from '@mui/icons-material/Highlight';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DateFnsAdapter from '@date-io/date-fns';
import { AxiosError } from 'axios';
import { ListingMeta } from '../ManagePacketsPage';
import { useHarmonicIntervalFn, useUpdateEffect } from 'react-use';
import { ReviewData } from '../../solicitor-viewer/components/Footer';
import { SocketActions } from 'state/socket/Action';

const dateFns = new DateFnsAdapter();

const RowContent: React.FC<ComponentRowContent> = React.forwardRef(
    (
        {
            _index: indices,
            uuid,
            row,
            page,
            setChildOpen,
            setModalOpen,
            setHighlightToggle,
            setBulkToggle,
            triggerDeletationModal,
        },
        ref
    ): React.ReactElement => {
        const dispatch = useDispatch();
        const authState = useSelector((state: any) => state.authState);
        const [namedOperator, setNamedOperator] = useState<string>('-');
        const profileState = useSelector((state: any) => state.profileState);
        const TableMetaProps = useContext(TableMeta);
        const isOpenByAnotherOperator = TableMetaProps?.data[indices];
        const labelId = `enhanced-table-checkbox-${indices}-${row.bin}-${page}`;
        const ListingMetaProps = React.useContext(ListingMeta);
        const socketState = useSelector(
            (stateRedux: any) => stateRedux.socketState
        );

        const socketCounter = React.useMemo(
            () => socketState.counter,
            [socketState.counter]
        );
        const socketEvent = React.useMemo(
            () => socketState.socketData.eventName,
            [socketState.socketData.eventName]
        );
        const socketPacketId = React.useMemo(
            () => socketState.socketData.packetId,
            [socketState.socketData.packetId]
        );
        const socketOperatorId = React.useMemo(
            () => socketState.socketData.operatorId,
            [socketState.socketData.operatorId]
        );

        const [activePacketId, setActivePacketId] = useState<null | string>(
            null
        );
        const [successPacket, setSuccessfulPacket] = useState<boolean>(false);

        const [pendingNavigation, setPendingNavigation] = useState<
            null | string
        >(null);

        const userInfo = useSelector(
            (state: any) => state.profileState.userInfo
        );
        const [activeEvent, setActiveEvent] = useState<boolean>(false);
        const [activeLookButton, setActivationLookButton] =
            useState<boolean>(false);

        useUpdateEffect(() => {
            if (
                activePacketId === null &&
                pendingNavigation === null &&
                activeEvent === false
            ) {
                setActivationLookButton(true);
            } else if (TableMetaProps && TableMetaProps.locker) {
                TableMetaProps.setLocker(
                    Array.from(TableMetaProps.locker).map((e, i) => {
                        if (i === indices) {
                            return true;
                        }

                        return e;
                    })
                );
            }
        }, [activePacketId, pendingNavigation]);
        useHarmonicIntervalFn(
            () => {
                if (activeLookButton) {
                    if (TableMetaProps && TableMetaProps.locker) {
                        TableMetaProps.setLocker(
                            Array.from(TableMetaProps.locker).map((e, i) => {
                                if (i === indices) {
                                    return false;
                                }

                                return e;
                            })
                        );
                    }
                    setActivationLookButton(false);
                }
            },
            activeLookButton ? 1000 : null
        );

        const isDataToggleExist = React.useMemo(() => {
            if (Object.keys(TableMetaProps?.toggleData ?? {}).includes(uuid)) {
                const i = Object.keys(
                    TableMetaProps?.toggleData ?? {}
                ).findIndex((e) => e === uuid);
                if (
                    Object.values(TableMetaProps?.toggleData ?? {}).at(i) ===
                    true
                ) {
                    return true;
                }
                return false;
            }
            return false;
        }, [TableMetaProps?.toggleData, uuid]);
        const [isOpen, setOpened] = React.useState(!!isDataToggleExist);
        const isDataStickyExist = React.useMemo(() => {
            if (Object.keys(TableMetaProps?.stickyData ?? {}).includes(uuid)) {
                const i = Object.keys(
                    TableMetaProps?.stickyData ?? {}
                ).findIndex((e) => e === uuid);
                if (
                    Object.values(TableMetaProps?.stickyData ?? {}).at(i) ===
                    true
                ) {
                    return true;
                }
                return false;
            }
            return false;
        }, [TableMetaProps?.stickyData, uuid]);
        const [isHighlight, setHighlight] = React.useState(!!isDataStickyExist);
        const isDataBulkExist = React.useMemo(() => {
            if (Object.keys(TableMetaProps?.bulkData ?? {}).includes(uuid)) {
                const i = Object.keys(TableMetaProps?.bulkData ?? {}).findIndex(
                    (e) => e === uuid
                );
                if (
                    Object.values(TableMetaProps?.bulkData ?? {}).at(i) === true
                ) {
                    return true;
                }
                return false;
            }
            return false;
        }, [TableMetaProps?.bulkData, uuid]);
        const [isBulk, setBulk] = React.useState(!!isDataBulkExist);
        const navigate = useNavigate();

        React.useImperativeHandle(
            ref,
            () => ({
                setClose: () => {
                    setOpened(false);
                },
                setOpen: () => {
                    setOpened(true);
                },
                isOpen: () => isOpen,
                setBulk: (val) => {
                    if (val) {
                        if (!isDataBulkExist) {
                            TableMetaProps?.setBulkData((prev) => {
                                const editPrev = {
                                    ...prev,
                                    [uuid]: true,
                                };
                                return editPrev;
                            });
                        }
                    } else {
                        // eslint-disable-next-line no-lonely-if
                        if (isDataBulkExist) {
                            TableMetaProps?.setBulkData((prev) => {
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const { [uuid]: test, ...filteredPrev } = prev;
                                return filteredPrev;
                            });
                        }
                    }
                    setBulk(val);
                },
            }),
            [TableMetaProps, isDataBulkExist, isOpen, uuid]
        );

        const renderOnLiteralToCreatePacketStatusClassName = (
            text: string
        ): string => {
            let className = 'defaultStatus';
            switch (text) {
                case 'Completed':
                case 'Categorisation Completed':
                    className = 'completed';
                    break;
                case 'Purged':
                    className = 'purged';
                    break;
                case 'Verified':
                    className = 'verified';
                    break;
                case 'Escalated':
                    className = 'escalated';
                    break;
                case 'Review Required':
                    className = 'review-required';
                    break;
                // case 'Sent for rework':
                //     className = 'sentrework';
                //     break;
                case 'Open By another Member':
                    className = 'openbyanother';
                    break;
                case 'Processing Verification':
                    className = 'processingqy';
                    break;
                default:
                    break;
            }
            return `${className} packet-status`;
        };
        const renderOnLiteralToCreateDataTypeClassName = (
            text: string,
            verified: boolean
        ): string => {
            let className = 'defaultType';
            switch (text) {
                case 'Fix':
                    className = 'fixed';
                    break;
                case 'Purged':
                    className = 'purged';
                    break;
                case 'Review':
                    className = 'reviewed';
                    break;
                case 'Duplication-Found':
                case 'Full-Duplicate':
                case 'Partial-Duplicate':
                case 'New-Duplicate':
                case 'Not-Expected':
                case 'Grouping-Failed':
                case 'Review-Escalated':
                    className = 'review-escalated';
                    break;
                case 'Verified':
                    if (verified === false) {
                        className = 'moveverified';
                        break;
                    }
                    className = 'move';
                    break;
                case 'Completed':
                    className = 'download';
                    break;
                case 'Escalated':
                    className = 'escalated';
                    break;
                case 'Sent-to-Rework':
                    className = 'rework';
                    break;
                case 'Open-by-another':
                    className = 'openbyanother';
                    break;
                case 'Uri-Completed':
                    className = 'uricompleted';
                    break;
                default:
                    break;
            }
            return className;
        };

        useLayoutEffect(() => {
            const lastName =
                typeof row.openedBy === 'object' && row.openedBy !== null
                    ? row.openedBy.last
                    : '';
            const firstName =
                typeof row.openedBy === 'object' && row.openedBy !== null
                    ? row.openedBy.first
                    : '';
            const nameOperator = String(firstName)
                .substring(0, 1)
                .toUpperCase();
            const namedOperator =
                typeof row.openedBy === 'object' && row.openedBy !== null
                    ? `${lastName}, ${nameOperator}`
                    : '-';

            if (namedOperator !== '-') {
                setNamedOperator(namedOperator);
            }
        }, []);
        const renderOnLiteralToCreateStringifyActions = React.useCallback(
            (text: string, row: Data): React.ReactNode => {
                let content: React.ReactNode = null;

                switch (text) {
                    case 'Escalated':
                        if (isOpenByAnotherOperator === true) {
                            content = `Open by ${namedOperator}`;
                        } else if (
                            (row.reviewRequired && row.escalated === true) ||
                            row.escalated === false
                        ) {
                            content = 'Review it';
                        } else {
                            content = (
                                <>
                                    Escalated <br />
                                    {`${row.updatedAtDifference} days ago`}
                                </>
                            );
                        }
                        break;
                    // case 'Sent-to-Rework':
                    //     content = (
                    //         <>
                    //             Sent for rework
                    //             <br />
                    //             {row.updatedAtDifference.toString()} days ago
                    //         </>
                    //     );
                    //     break;
                    case 'Purged':
                        content = 'Document purged';
                        break;
                    case 'Open-by-another':
                        content = `Open by ${namedOperator}`;
                        break;
                    case 'Uri-Completed':
                        content = 'Download';
                        break;
                    case 'Fix':
                        if (isOpenByAnotherOperator === true) {
                            content = `Open by ${namedOperator}`;
                        } else {
                            content = 'Fix it!';
                        }
                        break;
                    case 'Duplication-Found':
                    case 'Full-Duplicate':
                    case 'Partial-Duplicate':
                    case 'New-Duplicate':
                    case 'Not-Expected':
                    case 'Grouping-Failed':
                        if (isOpenByAnotherOperator === true) {
                            content = `Open by ${namedOperator}`;
                        } else {
                            content = 'View';
                        }
                        break;
                    case 'Review':
                        if (isOpenByAnotherOperator === true) {
                            content = `Open by ${namedOperator}`;
                        } else {
                            content = 'Review it!';
                        }
                        break;
                    case 'Review-Escalated':
                        if (isOpenByAnotherOperator === true) {
                            content = `Open by ${namedOperator}`;
                        } else {
                            content = 'Review it!';
                        }
                        break;
                    case 'Completed':
                        if (isOpenByAnotherOperator === true) {
                            content = `Opened by ${namedOperator}`;
                        } else {
                            content = 'Download';
                        }

                        break;
                    case 'Verified':
                        if (isOpenByAnotherOperator === true) {
                            content = `Opened by ${namedOperator}`;
                            break;
                        } else if (row.reportReviewed === false) {
                            content = 'Review Report';
                            break;
                        }
                        content = 'Move to Storage';
                        break;
                    default:
                        break;
                }
                return content;
            },
            [isOpenByAnotherOperator, namedOperator]
        );
        const generateLabelForOpenStatus = (
            localOpen: boolean,
            operatorOpen: boolean
        ): string => {
            let style = localOpen
                ? 'hidden align-center-content'
                : 'show align-center-content';

            if (operatorOpen) {
                style = localOpen
                    ? 'hidden align-center-content openByAnother'
                    : 'show align-center-content openByAnother';
            }
            return style;
        };
        const setActionObjsToReviewResponse = React.useCallback(
            (data: ReviewPacketData[]) =>
                Array.from(data).map((el) => ({
                    ...el,
                    isRead: false,
                    actions: formattingAction(el),
                })),
            []
        );
        const preSelectMissingDocument = React.useCallback(
            (currentStep: ReviewPacketData) => {
                if (currentStep?.result === 'Document Missing') {
                    return true;
                }
                if (currentStep && currentStep.result !== 'Paper Document') {
                    if (
                        currentStep.foundDocuments === 2 &&
                        currentStep.requiredDocuments === 2 &&
                        ((typeof currentStep.compareTo === 'object' &&
                            (currentStep.compareTo.documentId === null ||
                                typeof currentStep.compareTo.documentId ===
                                    'undefined')) ||
                            (typeof currentStep.compareWith === 'object' &&
                                (currentStep.compareWith.documentId === null ||
                                    typeof currentStep.compareWith
                                        .documentId === 'undefined')))
                    ) {
                        return true;
                    }
                    if (
                        currentStep.foundDocuments === 2 &&
                        currentStep.requiredDocuments === 1 &&
                        typeof currentStep.compareTo === 'object' &&
                        (currentStep.compareTo.documentId === null ||
                            typeof currentStep.compareTo.documentId ===
                                'undefined') &&
                        typeof currentStep.compareWith === 'object' &&
                        (currentStep.compareWith.documentId === null ||
                            typeof currentStep.compareWith.documentId ===
                                'undefined')
                    ) {
                        return true;
                    }
                    if (
                        currentStep.foundDocuments === 1 &&
                        currentStep.requiredDocuments === 1 &&
                        typeof currentStep.compareTo === 'object' &&
                        (currentStep.compareTo.documentId === null ||
                            typeof currentStep.compareTo.documentId ===
                                'undefined') &&
                        typeof currentStep.compareWith === 'object' &&
                        (currentStep.compareWith.documentId === null ||
                            typeof currentStep.compareWith.documentId ===
                                'undefined')
                    ) {
                        return true;
                    }
                    if (
                        currentStep.foundDocuments === 1 &&
                        currentStep.requiredDocuments === 2 &&
                        ((typeof currentStep.compareTo === 'object' &&
                            (currentStep.compareTo.documentId === null ||
                                typeof currentStep.compareTo.documentId ===
                                    'undefined')) ||
                            (typeof currentStep.compareWith === 'object' &&
                                (currentStep.compareWith.documentId === null ||
                                    typeof currentStep.compareWith
                                        .documentId === 'undefined')))
                    ) {
                        return true;
                    }
                    if (
                        currentStep.foundDocuments === 0 &&
                        currentStep.requiredDocuments === 1 &&
                        typeof currentStep.compareTo === 'object' &&
                        (currentStep.compareTo.documentId === null ||
                            typeof currentStep.compareTo.documentId ===
                                'undefined') &&
                        typeof currentStep.compareWith === 'object' &&
                        (currentStep.compareWith.documentId === null ||
                            typeof currentStep.compareWith.documentId ===
                                'undefined')
                    ) {
                        return true;
                    }
                }
                return false;
            },
            []
        );
        /**
         * preselect result value used in choose categories to validate the reviewed document
         * @param {ReviewPacketData[]} data - list current reviewed packets
         * @return {ReviewPacketData[]} changes in result for reviewed packets.
         */
        const getPreselectValidationResultForVerificationLabel =
            React.useCallback(
                (data: ReviewPacketData[]): ReviewPacketData[] =>
                    Array.from(data).map((el) => {
                        const isMissingDocument = preSelectMissingDocument(el);
                        const result = isMissingDocument
                            ? 'Document Missing'
                            : 'N/A';

                        return {
                            ...el,
                            result:
                                el.result === 'Correct' ||
                                el.result === 'Document Missing' ||
                                el.result === 'Escalated' ||
                                el.result === 'N/A' ||
                                el.result === 'Send For Rework' ||
                                el.result === 'Paper Document' ||
                                el.result === 'Hand Signed' ||
                                el.result === 'Sign Not Verified'
                                    ? el.result
                                    : result,
                        };
                    }),
                [preSelectMissingDocument]
            );
        useEffect(() => {
            if (activeEvent === true) {
                Promise.all([
                    ManagePacketService.getSinglePackets(activePacketId),
                    pendingNavigation === '/reviewer-viewer'
                        ? ManagePacketService.getReview({
                              packetId: activePacketId ?? '',
                          })
                        : undefined,
                ])
                    .then((responseArray) => {
                        const response = responseArray.at(0).data.data;
                        const formatingResponse = {
                            actions: {
                                type:
                                    response.status === ''
                                        ? typeMap.notExpected?.[0]
                                        : typeMap[response.status]?.[0],
                                ...formattingAction(response),
                            },
                            ...response,
                            bin: response.binNumber,
                            clientName: response.clientName,
                            completedDate: response.completedDate,
                            completedDateDifference:
                                response.completedDateDifference,
                            escalated: response.escalated,
                            escalatedDate: response.escalatedDate,
                            escalatedAtDifference:
                                response.ecalatedAtDifference,
                            escalatedByRole: response.escalatedByRole,
                            loanNumber: response.loanNumber,
                            operatorId: response.createdBy,
                            cm9Number: response.cm9Number,
                            packetStatus:
                                response.status === ''
                                    ? typeMap.notExpected?.[1]
                                    : typeMap[response.status]?.[1],
                            packetType: response.type,
                            recordNo: response.uniqueRef,
                            reason: response.statusMessage,
                            archiveDateDifference:
                                response.archiveDateDifference,
                            archiveTill: response.archiveTill,
                            SLADate: response.slaDate,
                            uploadedDate: response.createdAt,
                            documents: response.documents,
                            clientId: response.clientId,
                            createdAtDifference: response.createdAtDifference,
                            expiryDate: response.expiryDate,
                            expiryDateDifference: response.expiryDateDifference,
                            reportFile: response.reportFile,
                            reviewRequired: response.reviewRequired,
                            slaDateDifference: response.slaDateDifference,
                            updatedAtDifference: response.updatedAtDifference,
                            updatedAt: response.updatedAt,
                            file: response.file,
                            isOpen: response.operatorAction.open,
                            openedBy: response.operatorAction.openedBy,
                            enableAuditDownload: response.enableAuditDownload,
                            enableDocumentDownload:
                                response.enableDocumentDownload,
                            highlighted: response.highlighted,
                            packetAuditFile: response.packetAuditFile,
                            packetAuditFileCSV: response.packetAuditFileCSV,
                            cm9Timer: response.cm9Timer,
                            preferredDocuments: response.preferredDocuments,
                            placeholder: response.placeholder,
                            updateCategory: response.updateCategory,
                            showCategory: response.showCategory,
                            documentsRequired: response.documentsRequired,
                            expectedMissingDocuments:
                                response.expectedMissingDocuments,
                            operatorName: response.operatorName,
                            reportReviewed: response.reportReviewed,
                        };

                        if (
                            pendingNavigation &&
                            formatingResponse.operatorAction &&
                            formatingResponse.operatorAction.openedBy &&
                            formatingResponse.operatorAction.openedBy.first ===
                                userInfo.name.first &&
                            formatingResponse.operatorAction.openedBy.last ===
                                userInfo.name.last
                        ) {
                            if (pendingNavigation === '/reviewer-viewer') {
                                const responsePacket: {
                                    data: { data: ReviewData[] };
                                } = responseArray.at(1);
                                const dataKnownInstance =
                                    responsePacket.data.data.map((val) => {
                                        const stack = new Vertices();
                                        stack.current_object = val;

                                        return {
                                            ...val,
                                            stack,
                                        };
                                    });

                                // transition to detail reviewed
                                if (
                                    dataKnownInstance.filter((b) =>
                                        // eslint-disable-next-line no-underscore-dangle
                                        b.stack._knownInstance(b.stack)
                                    ).length === 0
                                ) {
                                    navigate('/single-reviewed', {
                                        state: {
                                            reviewData:
                                                setActionObjsToReviewResponse(
                                                    responsePacket.data.data
                                                ),
                                            documentData: {
                                                ...formatingResponse,
                                                isOpen: true,
                                            },
                                            primary: true,
                                        },
                                    });
                                } else {
                                    const dataHaveKnownInstance =
                                        dataKnownInstance.map((val) => {
                                            const updateStack = val.stack;
                                            const verticesSystem: VerticeSystem =
                                                val.stack as VerticeSystem;

                                            updateStack.matching =
                                                verticesSystem;

                                            return {
                                                ...val,
                                                stack: verticesSystem,
                                            };
                                        });

                                    const preSelectData =
                                        getPreselectValidationResultForVerificationLabel(
                                            dataHaveKnownInstance
                                        );

                                    const preSelectDataWithAction =
                                        setActionObjsToReviewResponse(
                                            preSelectData
                                        );
                                    const preSelectDataWithActionConvertTimeToRework =
                                        preSelectDataWithAction.map((e) => ({
                                            ...e,
                                            expiryDate: dateFns
                                                .addDays(
                                                    new Date(),
                                                    e.timeToRework ?? 0
                                                )
                                                .toString(),
                                        }));

                                    navigate(pendingNavigation, {
                                        state: {
                                            reviewData:
                                                preSelectDataWithActionConvertTimeToRework,
                                            documentData: {
                                                ...formatingResponse,
                                                isOpen: true,
                                            },
                                            ...formatingResponse,
                                            isOpen: true,
                                        },
                                    });
                                }
                            } else {
                                navigate(pendingNavigation, {
                                    state: {
                                        ...formatingResponse,
                                        isOpen: true,
                                    },
                                });
                            }

                            setActiveEvent(false);
                            setActivePacketId(null);
                            setPendingNavigation(null);
                        }
                    })
                    .catch((error) => {
                        Utils.handleErrorResponse(error);
                        setActiveEvent(false);
                        setActivePacketId(null);
                        setPendingNavigation(null);
                    });
            }
        }, [activeEvent]);
        useLayoutEffect(() => {
            dispatch(SocketActions.ResetSocketCounter());
        }, [socketCounter]);
        useLayoutEffect(() => {
            if (socketPacketId !== null && socketCounter !== 0) {
                if (
                    (socketEvent === 'packetStatus' ||
                        socketEvent === 'operatorAction') &&
                    activePacketId === socketPacketId &&
                    // eslint-disable-next-line no-underscore-dangle
                    (socketOperatorId === profileState.userInfo._id ||
                        typeof profileState.userInfo !== 'object')
                ) {
                    setActiveEvent(true);
                } else if (
                    (socketEvent === 'packetStatus' ||
                        socketEvent === 'operatorAction') &&
                    activePacketId === socketPacketId &&
                    activeEvent === false &&
                    typeof socketOperatorId !== 'undefined' &&
                    // eslint-disable-next-line no-underscore-dangle
                    socketOperatorId !== profileState.userInfo._id &&
                    successPacket === true
                ) {
                    setActiveEvent(true);
                    setActivePacketId(null);
                    setPendingNavigation(null);
                }
            }
        }, [socketCounter]);

        const handleForActionButton = React.useCallback(
            (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                if (row.actions.type === 'Fix') {
                    setSuccessfulPacket(false);
                    setActivePacketId(row.actions.uuid);
                    setPendingNavigation('/single-cross-check');
                    ListingMetaProps?.setActiveListing(true);
                    ManagePacketService.patchOperatorAction({
                        open: true,
                        packetId: row.actions.uuid,
                    })
                        .then(() => {
                            setSuccessfulPacket(true);
                            // if (TableMetaProps) {
                            //     TableMetaProps.data[indices] = true;
                            // }
                            // navigate('/single-cross-check', {
                            //     state: { ...response, isOpen: true },
                            // });
                        })
                        .catch((error) => {
                            const isAnotherPacket = !!(
                                error instanceof AxiosError &&
                                error.response &&
                                error.response.data &&
                                error.response.data.msg &&
                                String(error.response.data.msg).includes(
                                    'Another packet'
                                )
                            );
                            ManagePacketService.getSinglePackets(
                                row.actions.uuid
                            ).then((response) => {
                                const resp = response.data.data;
                                if (
                                    resp &&
                                    resp.operatorAction &&
                                    typeof resp.operatorAction.openedBy ===
                                        'object'
                                ) {
                                    const lastName =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? resp.operatorAction.openedBy.last
                                            : '';
                                    const firstName =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? resp.operatorAction.openedBy.first
                                            : '';
                                    const nameOperator = String(firstName)
                                        .substring(0, 1)
                                        .toUpperCase();
                                    const namedOperator =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? `${lastName}, ${nameOperator}`
                                            : '-';
                                    if (namedOperator !== '-') {
                                        if (
                                            TableMetaProps &&
                                            isAnotherPacket === false
                                        ) {
                                            TableMetaProps.data[indices] = true;
                                        }
                                        setNamedOperator(namedOperator);
                                    }
                                }
                            });

                            ListingMetaProps?.setActiveListing(false);
                            setPendingNavigation(null);
                            setActivePacketId(null);
                            setSuccessfulPacket(true);
                            if (
                                error !== null &&
                                error instanceof AxiosError &&
                                error.code === 'ERR_NETWORK'
                            ) {
                                Toast.showErrorMessage(
                                    'No internet connection, Please try again!'
                                );
                            } else {
                                Utils.handleErrorResponse(error);
                            }
                        });
                } else if (
                    row.actions.type === 'Review' ||
                    (row.actions.type === 'Escalated' && row.reviewRequired) ||
                    row.actions.type === 'Review-Escalated'
                ) {
                    setSuccessfulPacket(false);
                    setActivePacketId(row.actions.uuid);
                    setPendingNavigation('/reviewer-viewer');
                    ListingMetaProps?.setActiveListing(true);
                    ManagePacketService.patchOperatorAction({
                        open: true,
                        packetId: row.actions.uuid,
                    })
                        .then(() => {
                            // if (TableMetaProps) {
                            //     TableMetaProps.data[indices] = true;
                            // }

                            dispatch(
                                CarryAppActions.setSolicitorPacketId(
                                    row.actions.uuid
                                )
                            );
                            setSuccessfulPacket(true);

                            // navigate('/solicitor-viewer', {
                            //     state: { ...response, isOpen: true },
                            // });
                        })
                        .catch((error) => {
                            const isAnotherPacket = !!(
                                error instanceof AxiosError &&
                                error.response &&
                                error.response.data &&
                                error.response.data.msg &&
                                String(error.response.data.msg).includes(
                                    'Another packet'
                                )
                            );

                            ManagePacketService.getSinglePackets(
                                row.actions.uuid
                            ).then((response) => {
                                const resp = response.data.data;
                                if (
                                    resp &&
                                    resp.operatorAction &&
                                    typeof resp.operatorAction.openedBy ===
                                        'object'
                                ) {
                                    const lastName =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? resp.operatorAction.openedBy.last
                                            : '';
                                    const firstName =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? resp.operatorAction.openedBy.first
                                            : '';
                                    const nameOperator = String(firstName)
                                        .substring(0, 1)
                                        .toUpperCase();
                                    const namedOperator =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? `${lastName}, ${nameOperator}`
                                            : '-';

                                    if (namedOperator !== '-') {
                                        if (
                                            TableMetaProps &&
                                            isAnotherPacket === false
                                        ) {
                                            TableMetaProps.data[indices] = true;
                                        }
                                        setNamedOperator(namedOperator);
                                    }
                                }
                            });

                            ListingMetaProps?.setActiveListing(false);
                            setPendingNavigation(null);
                            setActivePacketId(null);
                            setSuccessfulPacket(true);
                            if (
                                error !== null &&
                                error instanceof AxiosError &&
                                error.code === 'ERR_NETWORK'
                            ) {
                                Toast.showErrorMessage(
                                    'No internet connection, Please try again!'
                                );
                            } else {
                                Utils.handleErrorResponse(error);
                            }
                        });
                } else if (row.actions.type === 'Purged') {
                    // console.log('purge');
                } else if (
                    row.actions.type === 'Not-Expected' ||
                    row.actions.type === 'Duplication-Found' ||
                    row.actions.type === 'Full-Duplicate' ||
                    row.actions.type === 'Partial-Duplicate' ||
                    row.actions.type === 'New-Duplicate' ||
                    row.actions.type === 'Grouping-Failed'
                ) {
                    setSuccessfulPacket(false);
                    setActivePacketId(row.actions.uuid);
                    setPendingNavigation('/not-expected-cross-check');
                    ListingMetaProps?.setActiveListing(true);
                    ManagePacketService.patchOperatorAction({
                        open: true,
                        packetId: row.actions.uuid,
                    })
                        .then(() => {
                            setSuccessfulPacket(true);
                            // if (TableMetaProps) {
                            //     TableMetaProps.data[indices] = true;
                            // }
                            // navigate('/not-expected-packet', {
                            //     state: { ...response, isOpen: true },
                            // });
                        })
                        .catch((error) => {
                            const isAnotherPacket = !!(
                                error instanceof AxiosError &&
                                error.response &&
                                error.response.data &&
                                error.response.data.msg &&
                                String(error.response.data.msg).includes(
                                    'Another packet'
                                )
                            );
                            ManagePacketService.getSinglePackets(
                                row.actions.uuid
                            ).then((response) => {
                                const resp = response.data.data;
                                if (
                                    resp &&
                                    resp.operatorAction &&
                                    typeof resp.operatorAction.openedBy ===
                                        'object'
                                ) {
                                    const lastName =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? resp.operatorAction.openedBy.last
                                            : '';
                                    const firstName =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? resp.operatorAction.openedBy.first
                                            : '';
                                    const nameOperator = String(firstName)
                                        .substring(0, 1)
                                        .toUpperCase();
                                    const namedOperator =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? `${lastName}, ${nameOperator}`
                                            : '-';
                                    if (namedOperator !== '-') {
                                        if (
                                            TableMetaProps &&
                                            isAnotherPacket === false
                                        ) {
                                            TableMetaProps.data[indices] = true;
                                        }
                                        setNamedOperator(namedOperator);
                                    }
                                }
                            });
                            ListingMetaProps?.setActiveListing(false);
                            setPendingNavigation(null);
                            setActivePacketId(null);
                            setSuccessfulPacket(true);
                            if (
                                error !== null &&
                                error instanceof AxiosError &&
                                error.code === 'ERR_NETWORK'
                            ) {
                                Toast.showErrorMessage(
                                    'No internet connection, Please try again!'
                                );
                            } else {
                                Utils.handleErrorResponse(error);
                            }
                        });
                } else {
                    setSuccessfulPacket(false);
                    setActivePacketId(null);
                    ListingMetaProps?.setActiveListing(false);
                    setPendingNavigation(null);
                    ManagePacketService.patchOperatorAction({
                        open: true,
                        packetId: row.actions.uuid,
                    })
                        .then(() => {
                            setSuccessfulPacket(true);
                            ManagePacketService.getSinglePackets(
                                row.actions.uuid
                            )
                                .then((resp) => {
                                    const response = resp.data.data;
                                    const formatingResponse = {
                                        actions: {
                                            type:
                                                response.status === ''
                                                    ? typeMap.notExpected?.[0]
                                                    : typeMap[
                                                          response.status
                                                      ]?.[0],
                                            ...formattingAction(response),
                                        },
                                        ...response,
                                        bin: response.binNumber,
                                        clientName: response.clientName,
                                        completedDate: response.completedDate,
                                        completedDateDifference:
                                            response.completedDateDifference,
                                        escalated: response.escalated,
                                        escalatedDate: response.escalatedDate,
                                        escalatedAtDifference:
                                            response.ecalatedAtDifference,
                                        escalatedByRole:
                                            response.escalatedByRole,
                                        loanNumber: response.loanNumber,
                                        operatorId: response.createdBy,
                                        cm9Number: response.cm9Number,
                                        packetStatus:
                                            response.status === ''
                                                ? typeMap.notExpected?.[1]
                                                : typeMap[response.status]?.[1],
                                        packetType: response.type,
                                        recordNo: response.uniqueRef,
                                        reason: response.statusMessage,
                                        archiveDateDifference:
                                            response.archiveDateDifference,
                                        archiveTill: response.archiveTill,
                                        SLADate: response.slaDate,
                                        uploadedDate: response.createdAt,
                                        documents: response.documents,
                                        clientId: response.clientId,
                                        createdAtDifference:
                                            response.createdAtDifference,
                                        expiryDate: response.expiryDate,
                                        expiryDateDifference:
                                            response.expiryDateDifference,
                                        reportFile: response.reportFile,
                                        reviewRequired: response.reviewRequired,
                                        slaDateDifference:
                                            response.slaDateDifference,
                                        updatedAtDifference:
                                            response.updatedAtDifference,
                                        updatedAt: response.updatedAt,
                                        file: response.file,
                                        isOpen: response.operatorAction.open,
                                        openedBy:
                                            response.operatorAction.openedBy,
                                        enableAuditDownload:
                                            response.enableAuditDownload,
                                        enableDocumentDownload:
                                            response.enableDocumentDownload,
                                        highlighted: response.highlighted,
                                        packetAuditFile:
                                            response.packetAuditFile,
                                        packetAuditFileCSV:
                                            response.packetAuditFileCSV,
                                        cm9Timer: response.cm9Timer,
                                        preferredDocuments:
                                            response.preferredDocuments,
                                        placeholder: response.placeholder,
                                        updateCategory: response.updateCategory,
                                        showCategory: response.showCategory,
                                        documentsRequired:
                                            response.documentsRequired,
                                        expectedMissingDocuments:
                                            response.expectedMissingDocuments,
                                        operatorName: response.operatorName,
                                        reportReviewed: response.reportReviewed,
                                    };
                                    setModalOpen(event, formatingResponse);
                                })
                                .catch(Utils.handleErrorResponse);
                        })
                        .catch((error) => {
                            const isAnotherPacket = !!(
                                error instanceof AxiosError &&
                                error.response &&
                                error.response.data &&
                                error.response.data.msg &&
                                String(error.response.data.msg).includes(
                                    'Another packet'
                                )
                            );
                            ManagePacketService.getSinglePackets(
                                row.actions.uuid
                            ).then((response) => {
                                const resp = response.data.data;
                                if (
                                    resp &&
                                    resp.operatorAction &&
                                    typeof resp.operatorAction.openedBy ===
                                        'object'
                                ) {
                                    const lastName =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? resp.operatorAction.openedBy.last
                                            : '';
                                    const firstName =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? resp.operatorAction.openedBy.first
                                            : '';
                                    const nameOperator = String(firstName)
                                        .substring(0, 1)
                                        .toUpperCase();
                                    const namedOperator =
                                        typeof resp.operatorAction.openedBy ===
                                            'object' &&
                                        resp.operatorAction.openedBy !== null
                                            ? `${lastName}, ${nameOperator}`
                                            : '-';
                                    if (namedOperator !== '-') {
                                        if (
                                            TableMetaProps &&
                                            isAnotherPacket === false
                                        ) {
                                            TableMetaProps.data[indices] = true;
                                        }
                                        setNamedOperator(namedOperator);
                                    }
                                }
                            });

                            ListingMetaProps?.setActiveListing(false);
                            setPendingNavigation(null);
                            setActivePacketId(null);
                            setSuccessfulPacket(true);
                            if (
                                error !== null &&
                                error instanceof AxiosError &&
                                error.code === 'ERR_NETWORK'
                            ) {
                                Toast.showErrorMessage(
                                    'No internet connection, Please try again!'
                                );
                            } else {
                                Utils.handleErrorResponse(error);
                            }
                        });
                }
            },
            [
                ListingMetaProps,
                TableMetaProps,
                dispatch,
                indices,
                row.actions.type,
                row.actions.uuid,
                row.reviewRequired,
                setModalOpen,
            ]
        );

        const parseSLADateDifferentToString = React.useCallback(() => {
            if (row.slaDateDifference) {
                if (row.slaDateDifference < 0) {
                    return `${formattingDate(row.SLADate)}`;
                }
                return `${formattingDate(row.SLADate)} (${
                    row.slaDateDifference
                } days left)`;
            }
            return '-';
        }, [row.SLADate, row.slaDateDifference]);

        const handleHighlightToggle = React.useCallback(
            (event: any) => {
                ManagePacketService.patchHighlightPacket({
                    highlight: !isHighlight,
                    packetId: row.actions.uuid,
                })
                    .then((response) => {
                        Utils.handleSuccessResponse(response);
                        setHighlightToggle(event, !isHighlight, indices);
                        setHighlight(!isHighlight);
                    })
                    .catch(Utils.handleErrorResponse);
            },
            [indices, isHighlight, row.actions.uuid, setHighlightToggle]
        );
        const handlePacketDeletation = React.useCallback(() => {
            if (typeof triggerDeletationModal === 'function') {
                triggerDeletationModal(row.actions.uuid);
            }
        }, [row.actions.uuid, triggerDeletationModal]);
        const handleCheckboxToggle = React.useCallback(
            (event: any) => {
                setBulkToggle(event, !isBulk, indices);
                setBulk(!isBulk);
            },
            [indices, isBulk, setBulkToggle]
        );

        const isReviewDisabled = React.useMemo(
            () =>
                row.packetStatus === 'Escalated' &&
                authState.role === 'senior' &&
                row.escalatedByRole === 'senior',
            [authState, row]
        );

        return (
            <>
                <TableCell
                    component="th"
                    id={labelId}
                    className={renderOnLiteralToCreatePacketStatusClassName(
                        row.packetStatus
                    )}
                    scope="row"
                >
                    <AppRadioBox
                        checked={isBulk}
                        color="primary"
                        labelPlacement="end"
                        disabled={(row.actions.type === 'Completed') === false}
                        onChange={handleCheckboxToggle}
                    />
                </TableCell>
                <TableCell
                    id={labelId}
                    className={renderOnLiteralToCreatePacketStatusClassName(
                        row.packetStatus
                    )}
                    scope="row"
                >
                    <Stack direction="column" className="stackContent">
                        <TypographyLevel
                            variant="three"
                            data-testid="packet-status"
                            className="contentStatus"
                        >
                            {row.packetStatus}
                        </TypographyLevel>
                    </Stack>
                </TableCell>
                <TableCell align="left">
                    <Stack direction="column" className="stackContent">
                        {isOpen && (
                            <TypographyLevel
                                variant="three"
                                className={
                                    row.slaDateDifference < 0 &&
                                    isHighlight &&
                                    (row.actions.type === 'Review-Escalated' ||
                                        row.actions.type === 'Review' ||
                                        row.actions.type === 'Escalated')
                                        ? 'contentTitle highlighted-textual'
                                        : 'contentTitle'
                                }
                            >
                                SLA
                            </TypographyLevel>
                        )}
                        <TypographyLevel
                            variant="three"
                            className={
                                row.slaDateDifference < 0 &&
                                (row.actions.type === 'Review-Escalated' ||
                                    row.actions.type === 'Review' ||
                                    row.actions.type === 'Escalated')
                                    ? 'different-days highlighted-textual'
                                    : 'different-days'
                            }
                            data-testid="SLADate"
                        >
                            {parseSLADateDifferentToString()}
                        </TypographyLevel>
                    </Stack>
                </TableCell>
                <TableCell align="left">
                    <Stack direction="column" className="stackContent">
                        <Stack direction="row" spacing={3}>
                            {/* <Box className="infography-cell">
                                <CellIcon className="info-icon" />
                            </Box> */}
                            <Stack direction="column">
                                <TypographyLevel
                                    variant="three"
                                    data-testid="loanNumber"
                                    className="contentLoanNumber"
                                >
                                    {row.loanNumber}
                                </TypographyLevel>
                                <TypographyLevel
                                    variant="three"
                                    data-testid="loanNumber"
                                    className="contentChecklistName"
                                >
                                    {row.clientName}
                                </TypographyLevel>
                            </Stack>
                        </Stack>
                    </Stack>
                </TableCell>
                <TableCell align="left">
                    <Stack direction="column" className="stackContent">
                        {/* {isOpen && (
                            <TypographyLevel
                                variant="three"
                                className="contentTitle"
                            >
                                Bin Number
                            </TypographyLevel>
                        )} */}
                        <TypographyLevel
                            variant="three"
                            data-testid="binNumber"
                            className="contentBinNumber"
                        >
                            {row.bin}
                        </TypographyLevel>
                    </Stack>
                </TableCell>

                <TableCell align="left" className="actions-stack">
                    <Box className="component-actions">
                        {row.actions.type === 'Open-by-another' ||
                        row.actions.type === 'Sent-to-Rework' ||
                        row.actions.type === 'Pending' ||
                        row.actions.type === 'Categorisation-Completed' ||
                        row.actions.type === 'No-Reworked' ||
                        row.actions.type === 'Origin-Attachment' ||
                        row.actions.type === 'Duplication-Packet' ||
                        row.actions.type === 'Document-Missing' ||
                        row.actions.type === 'Empty-Packet' ||
                        row.actions.type === 'Virus-Found' ||
                        row.actions.type === 'Encrypted' ||
                        row.actions.type === 'Corrupted' ||
                        row.actions.type === 'Categorising' ||
                        row.actions.type === 'No-Documents-Found' ||
                        row.actions.type === 'Verifying' ||
                        row.actions.type === 'Sent-for-Rework' ||
                        row.actions.type === 'Validation-Failed' ||
                        row.actions.type === 'Reworked' ||
                        row.actions.type === 'Uploading' ||
                        row.actions.type === 'Scanning' ||
                        row.actions.type === 'Scanning-Completed' ||
                        row.actions.type === 'Grouping-Completed' ||
                        row.actions.type === 'Grouping' ||
                        row.actions.type === 'Purged' ||
                        row.actions.type === 'Generating-Report' ||
                        (row.actions.type === 'Escalated' &&
                            (!row.reviewRequired ||
                                authState.role === 'operator' ||
                                row.escalated === false)) ||
                        (row.actions.type === 'Review' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'Verified' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'Completed' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'Fix' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'Not-Expected' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'Escalated' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'Review-Escalated' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'Duplication-Found' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'Full-Duplicate' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'Partial-Duplicate' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'New-Duplicate' &&
                            isOpenByAnotherOperator === true) ||
                        (row.actions.type === 'Grouping-Failed' &&
                            isOpenByAnotherOperator === true) ||
                        row.actions.type === 'Processing' ? (
                            <TypographyLevel
                                variant="three"
                                className={generateLabelForOpenStatus(
                                    isOpen && isOpenByAnotherOperator === false,
                                    isOpenByAnotherOperator ?? false
                                )}
                            >
                                {renderOnLiteralToCreateStringifyActions(
                                    row.actions.type,
                                    row
                                )}
                            </TypographyLevel>
                        ) : (
                            <Box className="action-to-submits">
                                <Formik
                                    initialValues={{
                                        smallInput: 'Insert Here',
                                    }}
                                    enableReinitialize
                                    onSubmit={() => {
                                        // console.log();
                                    }}
                                >
                                    <AppPrimaryButton
                                        title={renderOnLiteralToCreateStringifyActions(
                                            row.actions.type,
                                            row
                                        )}
                                        disabled={
                                            isReviewDisabled ||
                                            activePacketId !== null ||
                                            (TableMetaProps &&
                                            TableMetaProps.locker
                                                ? TableMetaProps.locker.some(
                                                      (e) => e === true
                                                  )
                                                : false)
                                        }
                                        onClick={handleForActionButton}
                                        className={`btn-small ${renderOnLiteralToCreateDataTypeClassName(
                                            row.actions.type,
                                            row.reportReviewed
                                        )}`}
                                        aria-haspopup={
                                            row.actions.type === 'Verified' ||
                                            row.actions.type === 'Completed'
                                                ? 'dialog'
                                                : 'false'
                                        }
                                    />
                                </Formik>
                            </Box>
                        )}
                    </Box>
                </TableCell>
                <TableCell align="left">
                    <Stack
                        direction="row"
                        className="icon-group"
                        alignItems="center"
                        spacing={4}
                        marginLeft={5}
                    >
                        <Box
                            className="highlight-button"
                            onClick={handleHighlightToggle}
                            title="highlight-packet-details"
                        >
                            {!isHighlight && (
                                <HighlightIcon className="icon-highlight-off-color" />
                            )}
                            {isHighlight && (
                                <HighlightOffIcon className="icon-highlight-on-color up" />
                            )}
                        </Box>
                        {authState.role !== 'operator' &&
                            (row.actions.type === 'Virus-Found' ||
                                row.actions.type === 'No-Documents-Found' ||
                                row.actions.type === 'Duplication-Found' ||
                                row.actions.type === 'Fix' ||
                                row.actions.type === 'Grouping-Failed' ||
                                row.actions.type === 'Review' ||
                                row.actions.type === 'Verified' ||
                                row.actions.type === 'Sent-for-Rework' ||
                                row.actions.type === 'Reworked' ||
                                row.actions.type === 'Escalated' ||
                                row.actions.type === 'Not-Expected' ||
                                row.actions.type === 'Origin-Attachment' ||
                                row.actions.type === 'Full-Duplicate' ||
                                row.actions.type === 'Partial-Duplicate' ||
                                row.actions.type === 'New-Duplicate' ||
                                row.actions.type === 'Purged' ||
                                row.actions.type === 'Validation-Failed' ||
                                row.actions.type === 'Encrypted' ||
                                row.actions.type === 'Completed' ||
                                row.actions.type === 'Corrupted') && (
                                <Box
                                    onClick={handlePacketDeletation}
                                    title="delete packet"
                                    aria-haspopup="dialog"
                                    className="deletation-button"
                                >
                                    <DeleteIcon className="icon-deletation-on-color" />
                                </Box>
                            )}
                        <Box
                            onClick={(event: any) => {
                                setChildOpen(event, labelId, indices);
                            }}
                            aria-expanded={isOpen}
                            role="button"
                            aria-controls="panel-tablerow"
                            id="action-dropdown-tablerow"
                            title="dropdown-packet-details"
                        >
                            {isOpen && (
                                <ChevronUp className="icon-drop-down-color" />
                            )}
                            {!isOpen && (
                                <ChevronDown className="icon-drop-down-color" />
                            )}
                        </Box>
                    </Stack>
                </TableCell>
            </>
        );
    }
);

export default RowContent;
